import * as React from 'react';

import IConfig from '@sitegen/common/constants/config';

import { OVERLAY_ID } from './header-login.constants';

import ubisoftOverlayService from 'modules/ubisoft-overlay-service/service';

import './header-login.styles.less';

export class HeaderLogin extends React.Component<IHeaderLoginProps> {
    constructor(props: IHeaderLoginProps) {
        super(props);

        const { config, activeLanguageCode } = props;

        ubisoftOverlayService.configure({
            env: config.envName,
            appId: config.applicationId,
            genomeId: config.genomeId,
            locale: activeLanguageCode,
        });
    }

    public componentDidMount(): void {
        ubisoftOverlayService.init(OVERLAY_ID);
    }

    public render() {
        return (
            <div className="sitegen-user">
                <div id={OVERLAY_ID} />
            </div>
        );
    }
}

export interface IHeaderLoginProps {
    readonly config: IConfig;
    readonly activeLanguageCode: string;
}

export default HeaderLogin;
